import React, { useState, useEffect } from "react";
import Sidebar from "../Sidebar/Sidebar";
import Navbar from "./Navbar";
import Header from "./header";
import TableContainer from "@mui/material/TableContainer";
import Paper from "@mui/material/Paper";
import moment from "moment";
import WinloseTable from "./WinloseTable";
import ApiConfig from "../../common/config/ApiConfig";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useLocation, useNavigate } from "react-router-dom";

function Winlose() {
  const [tablecontrol, setTablecontrol] = useState("downline");
  const location = useLocation();
  const navigate = useNavigate();
  const searchParams = new URLSearchParams(location.search);
  const username = searchParams.get("username");
  const seniorParam = searchParams.get("senior");
  const masterParam = searchParams.get("master");
  const agentParam = searchParams.get("agent");
  const startdateParam = searchParams.get("startdate");
  const enddateParam = searchParams.get("enddate");

  const [showorder, setShowrder] = useState([]);
  const [position, setPosition] = useState([]);
  const user = localStorage.getItem("user");

  const [startdate, setStartdate] = useState(
    startdateParam || moment().startOf("month").format("YYYY-MM-DD"),
  );
  const [endtdate, setEndtdate] = useState(
    enddateParam || moment().endOf("month").format("YYYY-MM-DD"),
  );
  const [lottoselect, setLottoselect] = useState([
    "th_gov",
    "laos_gov",
    "Yeekee_5",
    "Yeekee_10",
    "Yeekee_15",
  ]);

  const OrderGet = () => {
    const params = new URLSearchParams({
      user: username ?? user,
      startdate: startdate,
      enddate: endtdate,
    });
    // qs (Express's query parser) only returns an array for a repeated key
    // — a single `lottotype=x` parses as a plain string, failing the
    // backend's `type: "array"` check. The `lottotype[]=` bracket form
    // forces an array even when only one value is selected.
    lottoselect.forEach((type) => params.append("lottotype[]", type));
    ApiConfig.get(`/sumorder?${params.toString()}`).then((result) => {
      if (result.resCode !== 200) {
        toast.error(result.message || "เกิดข้อผิดพลาดในการโหลดข้อมูล", {
          autoClose: 2000,
        });
        return;
      }
      setShowrder(result.data);
      setPosition(result.position);
      setTablecontrol("downline");
      //alert(startdate)
    });
  };

  const lottoTypeMappings = {
    th_gov: "หวยรัฐบาลไทย",
    laos_gov: "หวยรัฐบาลลาว",
    hanoy_PhuQua: "หวยฮานอย",
    Yeekee_5: "หวยยี่กี่",
    Yeekee_10: "หวยยี่กี่ VIP",
    Yeekee_15: "หวยยี่กี่ VVIP",
  };
  useEffect(() => {
    OrderGet();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.search]);

  // Keep the selected date range reflected in the URL (merged with whatever
  // params are already there — username/senior/master/agent) so the range
  // survives a refresh or gets carried into a shared link, same as those
  // drill-down params already do.
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    params.set("startdate", startdate);
    params.set("enddate", endtdate);
    const nextSearch = `?${params.toString()}`;
    if (nextSearch !== location.search) {
      navigate(
        { pathname: location.pathname, search: nextSearch },
        { replace: true },
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [startdate, endtdate]);

  const pos = localStorage.getItem("position");

  return (
    <div className="h-screen flex flex-col overflow-hidden">
      <div className="shrink-0">
        <Navbar />
      </div>
      <div className="flex flex-1 overflow-hidden items-start">
        <div className="shrink-0 overflow-y-auto h-full">
          <Sidebar pos={pos} />
        </div>
        <div className="flex flex-col flex-1 max-h-full overflow-hidden">
          <div className="shrink-0">
            <Header title="Win & Lose" />
          </div>
          <div className="flex-1 overflow-y-auto">
            <TableContainer component={Paper}>
              <TableContainer component={Paper}>
                {tablecontrol === "downline" && (
                  <WinloseTable
                    data={showorder}
                    startdate={startdate}
                    enddate={endtdate}
                    setstartdate={setStartdate}
                    setenddate={setEndtdate}
                    fetch={OrderGet}
                    lottoselect={lottoselect}
                    setLottoselect={setLottoselect}
                    lottoTypeMappings={lottoTypeMappings}
                    pos={position}
                    seniorParam={seniorParam}
                    masterParam={masterParam}
                    agentParam={agentParam}
                  />
                )}
              </TableContainer>
            </TableContainer>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Winlose;
